import { InjectionToken } from "@angular/core";
import { ILaunchDarklyConfig, ISsoOutBound } from "./config.interface";

export const ENVIRONMENT = new InjectionToken<string>('ENVIRONMENT');
export const HELIOS_SSO = new InjectionToken<ISsoOutBound>('HELIOS_SSO');
export const LEGACY_SSO = new InjectionToken<ISsoOutBound>('LEGACY_SSO');
export const LAUNCH_DARKLY = new InjectionToken<ILaunchDarklyConfig>('LAUNCH_DARKLY');
